<template>
    <el-dialog
        :title="$t('c.select')+' '+ titleText"
        :visible.sync="visible"
        custom-class="resource-dialog"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        width="80%">

        <div class="dialog-body">
            <el-row>
                <el-col :span="12">
                    <el-form class="query-form" ref="form" :inline="true" size="mini" @submit.native.prevent>
                        <el-form-item :label="$t('c.name')">
                            <el-input v-model="form.name" @keyup.enter.native="query(1)" :placeholder="$t('tip.resName')" clearable></el-input>
                        </el-form-item>

                        <el-button class="btn-query" type="primary" size="mini" @click="query(1)">{{$t('c.query')}}</el-button>
                    </el-form>
                </el-col>
            </el-row>


            <div class="resource-panel" v-loading="loading">
                <el-row class="resourceList" :gutter="20" >
                    <el-col class="resourceList-item" v-for="item in resourceList" :index="item.id" :key="item.id" :span="4">
                        <div @click.prevent="clickCard(item.id)" style="cursor: pointer">
                            <el-card :body-style="{ padding: '2px' }" class="item-card" >
                                <div class="item-image" v-if="item.type==12">
                                    <img :src="item.thumbnail" class="image" >
                                </div>
                                <div class="item-image" v-if="item.type==11">
                                    <img src="../../assets/images/course/audio.png" class="image" >
                                </div>
                                <div class="item-image" v-if="item.type==10">
                                    <img src="../../assets/images/course/video.png" class="image">
                                </div>
                                <div class="item-image" v-if="item.type==8 && item.extension=='.pdf'">
                                    <img src="../../assets/images/document/pdf.png" class="image" >
                                </div>
                                <div class="item-image" v-if="item.type==8 && (item.extension=='.xls'||item.extension=='.xlsx')">
                                    <img src="../../assets/images/document/excel.png" class="image" >
                                </div>
                                <div class="item-image" v-if="item.type==8 && (item.extension=='.ppt'||item.extension=='.pptx')">
                                    <img src="../../assets/images/document/ppt.png" class="image" >
                                </div>
                                <div class="item-image" v-if="item.type==8 && item.extension=='.txt'">
                                    <img src="../../assets/images/document/txt.png" class="image" >
                                </div>
                                <div class="item-image" v-if="item.type==8 && (item.extension=='.doc'||item.extension=='.docx')">
                                    <img src="../../assets/images/document/word.png" class="image" >
                                </div>
                                <div class="item-image" v-if="item.type==8 && item.extension!='.doc'&& item.extension!='.docx' && item.extension!='.txt' && item.extension!='.ppt' && item.extension!='.xls' && item.extension!='.pptx' && item.extension!='.xlsx' && item.extension!='.pdf'">
                                    <img src="../../assets/images/document/undefined.png" class="image" >
                                </div>
                                <div class="object-info">
                                        <p class="object-name">{{item.name}}</p>
                                        <el-checkbox
                                            v-model="selectItems"
                                            :label="item.id"
                                            :disabled="disabled[item.id]">{{ }}</el-checkbox>
                                </div>
                            </el-card>
                        </div>
                    </el-col>
                </el-row>
                <div>
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        layout="total, prev, pager, next, jumper"
                        :total="pagTotal"
                        :page-size="12"
                        style="text-align: center;">
                    </el-pagination>
                </div>

                <!--<p v-show="!pagTotal" style="margin-top: 20px;text-align: center;font-size: 18px;">-->
                    <!--<i class="nucfont inuc-empty-file"></i> {{$t('c.noData')}}-->
                <!--</p>-->
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button type="success" @click="selectOver">{{$t('c.confirm')}}</el-button>
            <el-button @click="visible = false">{{$t('c.cancel')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {mapGetters} from 'vuex';
    import api from '../../api/index';

    export default {
        props: {
            type:{
                type: Number     // 8文档 10视频 12图片
            },
            dialogOpen: {
                type: Boolean,
                default: false,
            },

        },
        data() {
            return {
                visible: false,
                pagTotal: 0,
                currentPage: 1,
                form: {
                    name: '',
                    types: 0
                },
                resourceList:'',       //右边的课程数据
                selectItems: [],      //选中的项
                selectValue: [],
                loading: false,
                disabled: {},

            }
        },
        created() {
            this.query()
        },
        computed: {
            titleText() {
                let title
                let resType= this.type
                switch (resType){
                    case 8:
                        title = this.$t('c.document')
                        break;
                    case 10:
                        title = this.$t('c.video')
                        break;
                    case 11:
                        title = this.$t('c.audio')
                        break;
                    default:
                        title = this.$t('c.image')
                        break
                }
                return title
            }
        },
        methods: {
            // 打开对话框的事件
            initDialog() {
                this.form.types = this.type;
                this.currentPage=1;
                this.query();
            },
            resetDialog() {
                this.form = {
                    name: '',
                    types: 0
                };
                this.selectItems = [];
                this.disabled = {};
            },
            query(num) {
                if (num) this.currentPage = num

                this.loading = true;
                let queryData = {
                    ...this.form,
                    pageNO: this.currentPage,
                    limit: 12,
                };
                !queryData.name && delete queryData.name;
                    api.queryResourceByType(queryData).then((res) => {
                        this.loading = false;
                        this.resourceList = res.package;
                        this.pagTotal = res.total;
                    });
            },
            clickCard(id) {
                if (this.disabled[id]) return;
                    let index = this.selectItems.indexOf(id);
                    if (index < 0) {
                        this.selectItems=[]
                        this.selectItems.push(id);
                    } else {
                        this.selectItems.splice(index, 1);
                    }
            },
            // 页码变化
            handleCurrentChange(val) {

                this.currentPage = val;

                this.loading = true;

                this.query();
            },
            selectOver() {
                this.$emit('onSelectOver', this.selectValue);
                this.visible = false;
            },
            currentChange(num) {
                this.page.currentPage = num;
            }
        },
        watch: {
            selectItems(val) {
                let arr = [];

                //根据id找数据
                if (!this.resourceList) return;

                val.forEach(id => {
                    let data = this.resourceList.find(ele => ele.id === id);
                    if (data) {
                        arr.push(data);
                    }
                });

                this.selectValue = arr;
            },
            visible(val) {
                // 打开
                if (val) {
                    this.$nextTick(() => {
                        $('.sub-page').css({
                            overflow: 'hidden'
                        })
                    });
                    this.initDialog();
                // 关闭
                } else {
                    this.$emit('onDialogClosed', false);

                    $('.sub-page').css({
                        overflow: 'auto'
                    });

                    this.resetDialog();
                }
            },
            dialogOpen() {
                this.visible = this.dialogOpen;
            }
        },
        components: {}
    }
</script>

<style lang="scss">
    .resource-dialog {
        min-width: 1000px;

        .el-dialog__header {
            padding: 10px 15px;
            border-bottom: 1px solid #ccc;
        }
        .el-dialog__body {
            padding-top: 20px;
            background-color: #F8F8F8;
        }
        .el-dialog__footer {
            padding: 10px 20px;
        }

        .resourceList{
            min-height: 340px;
            .resourceList-item{
                margin-bottom: 10px;
                .item-card{
                    padding: 5px;
                    height: 160px;
                    &:hover{
                        box-shadow: 1px 3px 8px 0 rgba(0, 0, 0, 0.3);
                    }
                    .item-image{
                        height: 110px;
                        width: 100%;
                        text-align: center;
                        img{
                            height: 100%;
                        }
                    }
                }
            }
        }

        .object-info{
            padding-top:8px;
            padding-left: 5px;
            display: flex;
            justify-content: space-between;
            color: #333;
            .object-name{
                font-size: 12px;
                color: #676a6c;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

</style>
